<script>
	import { onMount, onDestroy } from "svelte";
	import { navigate } from "svelte-routing";
	import { Button, Col, Row } from "sveltestrap";
	import queryString from "query-string";
	import client from "../../../services/client";
	import {
		errorMessage,
		sizeSelect,
		totalPages,
		loading,
		loadingStatus,
		initPage,
	} from "../../../store/store";
	import CarparkManagementTable from "./CarparkManagementTable.svelte";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import FilterForm from "../../../components/FilterForm/FilterForm.svelte";
	import SelectSize from "../../../components/SizeSelect/SizeSelect.svelte";
	import { extractErrorMessage, handleCsvImport } from "src/utils/misc";

	let data = [];

	//Start Logic for filter feature
	const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop),
	});
	$: queryParams = `?page=1&size=${$sizeSelect}`;
	let searchParams = window.location.search.toString();
	let queryPage = searchParams.includes("page");
	let queryStatus = searchParams.includes("carparkStatus");
	let queryKeyword = searchParams.includes("keyword");
	let queryStartDateRange = searchParams.includes("startDateRange");
	let queryEndDateRange = searchParams.includes("endDateRange");

	$: if (queryPage) {
		queryParams = `?page=${params.page}&size=${$sizeSelect}`;
	}
	$: if (queryStatus) {
		queryParams = queryParams.concat(`&status=${params.carparkStatus}`);
	}
	$: if (queryKeyword) {
		queryParams = queryParams.concat(`&keyword=${params.keyword}`);
	}
	$: if (queryStartDateRange) {
		queryParams = queryParams.concat(`&startDate=${params.startDateRange}`);
	}
	$: if (queryEndDateRange) {
		queryParams = queryParams.concat(`&endDate=${params.endDateRange}`);
	}

	//End Logic for filter feature

	async function fetchCarparks() {
		try {
			loading.set(true);
			const res = await client(`/v1/carParks/filter${queryParams}`, {
				method: "GET",
				version: "Vehicle",
			});
			data = res.data.dataList;
			data.totalCount = res.data.totalCount;
			totalPages.set(res.data.totalPage);
			if (res.data.dataList) {
				loading.set(false);
				loadingStatus.set(false);
			}
		} catch (err) {
			loading.set(false);
			extractErrorMessage(err);
			console.log(err.response);
		}
	}

	$: $sizeSelect, trigerSelectCarpark();

	onDestroy(() => {
		initPage.set(1);
		sizeSelect.set("20");
		totalPages.set(1);
	});

	const trigerSelectCarpark = async (e) => {
		if (e === "update") {
			loadingStatus.set(true);
		} else {
			loading.set(true);
		}
		fetchCarparks();
	};

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});
</script>

<Row>
	<Col xs={12}>
		<div>
			<ErrorMessageHandler message={err} />
			<Row className="align-items-center mb-3">
				<Col>
					<PageHeader title="Carpark Management" />
				</Col>
				<Col
					xs="auto"
					class="d-flex justify-content-end align-items-center"
				>
					<div class="d-flex align-items-start">
						<div class="mx-2 d-flex flex-column align-items-center">
							<input
								id="fileInput"
								type="file"
								multiple={false}
								hidden="hidden"
								on:change={(e) =>
									handleCsvImport(
										e,
										"/v1/carParks/csvFileImport",
										"Vehicle"
									)}
							/>
							<label
								type="button"
								for="fileInput"
								id="customButton"
								class="btn themeButton primary px-4"
								block>Import CSV</label
							>
							<a
								href="/assets/csv/Carpark_Template.csv"
								target="_blank"
								download="carpark_template.csv"
								rel="noreferrer"
								class="link link-text"
								style="font-size: 16px;"
							>
								Download CSV Template
							</a>
						</div>
						<div class="mx-2 d-flex align-items-center">
							<Button
								class="themeButton primary px-4"
								on:click={() =>
									navigate("carpark-management/create")}
								>Add Carpark</Button
							>
						</div>
					</div>
				</Col>
			</Row>
			<!-- <div class="mx-2">
						<Button
							on:click={() => handleExportCSV(0)}
							class="themeButton primary px-4">Export CSV</Button
						>
					</div> -->

			<div class="d-flex flex-row justify-content-between">
				<Col xs={6}>
					<FilterForm
						keyword
						carparkStatus
						startDateRange
						endDateRange
					/>
				</Col>
				<div class="align-self-end">
					<SelectSize trigerSelect={fetchCarparks} />
				</div>
			</div>
		</div>
	</Col>
	<Col class="my-2">
		<CarparkManagementTable {data} {trigerSelectCarpark} />
	</Col>
</Row>
